import {
	createRouter,
	createWebHistory,
	createWebHashHistory
} from 'vue-router'
// 导入路由下所有.js路由文件
const Routers = import.meta.glob("./module/*.js",{eager:true});
const RouterList = [];
Object.keys(Routers).forEach((item) => {
	Object.keys(Routers[item]).forEach((key) => {
		RouterList.push(...Routers[item][key]);
	});
});
export const constantRouterMap = [
	{
		path: '/',
		hidden:true,
		redirect: '/home',
	},
	{
		path: '/Login',
		name: 'Login',
		hidden:true,
		component: () => import('@/views/Login.vue'),
		meta: {
			title: "登录",
		}
	},
	{
		path: '/forgetPassword',
		name: 'forgetPassword',
		hidden:true,
		component: () => import('@/views/Password/forgetPassword.vue'),
		meta:{
			title:'忘记密码',
		},
	},
]

const router = createRouter({
	history: createWebHashHistory(import.meta.env.BASE_URL),
	routes:constantRouterMap
})
export default router
export  { RouterList } 
